const isValidHour = (h) => h.length < 2 || Number(h) <= 23;
const isValidMinute = (m) => m.length === 0 ||
    (m.length === 1 && Number(m) <= 5) ||
    (m.length === 2 && Number(m) <= 59);
export const formatTypedTime = (raw) => {
    if (/[^\d:.]/.test(raw)) {
        return null;
    }
    const parts = raw.split(/[:.]/);
    if (parts.length > 2) {
        return null;
    }
    if (parts.length === 2) {
        const [h, m] = parts;
        if (h.length > 2 || m.length > 2 || !isValidHour(h) || !isValidMinute(m)) {
            return null;
        }
        return `${h}:${m}`;
    }
    const digits = parts[0];
    if (digits.length > 4) {
        return null;
    }
    const hourDigits = digits.length > 0 && Number(digits[0]) > 2 ? 1 : 2;
    const h = digits.slice(0, hourDigits).padStart(Math.min(digits.length, 2), "0");
    const m = digits.slice(hourDigits);
    if (!isValidHour(h) || !isValidMinute(m)) {
        return null;
    }
    return m.length > 0 ? `${h}:${m}` : digits;
};
export const toTimeValue = (text) => {
    const match = /^(\d{1,2}):(\d{2})$/.exec(text);
    return match ? `${match[1].padStart(2, "0")}:${match[2]}` : "";
};
export const completeTime = (text) => {
    if (text === "") {
        return "";
    }
    const [h, m = ""] = text.split(":");
    return `${(h || "0").padStart(2, "0")}:${m.padEnd(2, "0")}`;
};
export const segmentAt = (text, caret) => {
    const colon = text.indexOf(":");
    return colon === -1 || caret <= colon ? "hour" : "minute";
};
export const segmentRange = (segment) => segment === "hour" ? [0, 2] : [3, 5];
export const stepTime = (text, segment, delta) => {
    const [h, m] = (completeTime(text) || "00:00").split(":").map(Number);
    const wrap = (n, size) => (n + delta + size) % size;
    const pad = (n) => String(n).padStart(2, "0");
    return segment === "hour"
        ? `${pad(wrap(h, 24))}:${pad(m)}`
        : `${pad(h)}:${pad(wrap(m, 60))}`;
};
export const caretAfterDigits = (text, n) => {
    if (n === 0) {
        return 0;
    }
    let seen = 0;
    for (let i = 0; i < text.length; i++) {
        if (/\d/.test(text[i]) && ++seen === n) {
            return i + 1;
        }
    }
    return text.length;
};
export const digitsBefore = (text, caret) => text.slice(0, caret).replace(/\D/g, "").length;
//# sourceMappingURL=time-input-format.js.map